
import { Snackbar } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { AppNotificationTypeEnum } from "../../contexts/app-notification-context/AppNotificationContextTypes";
import { useAppNotificationContext } from "../../contexts/app-notification-context/UseAppNotificationContext";
import { Alert } from "@mui/material";

export default function AppNotificationToast() {

    const [open, setOpen] = useState(false);
    const [appNotificationState, setAppNotificationState] = useAppNotificationContext();

    const onClose = () => {
        setAppNotificationState({
            ...appNotificationState,
            show: false
        });
    };

    useEffect(() => {

        if (appNotificationState.notificationType === AppNotificationTypeEnum.Success) {
            if (appNotificationState.show && !open) {
                setOpen(true);
            } else if (!appNotificationState.show && open) {
                setOpen(false);
            }
        } 

    }, [appNotificationState.show, 
        appNotificationState.notificationType, 
        open, 
        setOpen]);

    return (
        <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={open}
            onClose={onClose}
            autoHideDuration={5000}>        
            <Alert onClose={onClose} severity="success" sx={{ width: '100%' }}>
                {appNotificationState.message}
            </Alert>
        </Snackbar>
    );
  }
